module.exports = "/_next/static/images/kidney_BI-2c49cc36ed1332f18c725d3e420ecd40.png";